module.exports = __webpack_public_path__ + "static/img/table.36dec6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/n-prenata-test/table.png
// module id = D96A
// module chunks = 1